import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';

export interface InvalidPlayerInterface {
    readonly player: PlayerInterface;
    readonly invalidProps: string[];
}

export class InvalidPlayer implements InvalidPlayerInterface {
    constructor(public readonly player: PlayerInterface, public readonly invalidProps: string[]) {}

    public static create(player: PlayerInterface, invalidProps: string[]): InvalidPlayerInterface {
        return new InvalidPlayer(player, invalidProps);
    }
}
